import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import AddCircleIcon from '@material-ui/icons/AddCircle';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { baseTheme } from '../../../../theme';

import { IPostActionButton } from '../interfaces';

import { createPostAction, getPostsAction, newUser, setAppLoadingState } from '../../../../store';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.main,
      paddingBottom: '5px',
      textAlign: 'center',
      '&:hover': {
        paddingBottom: '0',
        borderBottom: 'solid 5px',
        borderColor: theme.palette.primary.main,
      },
    },
    colorPrimary: {
      color: theme.palette.primary.main,
    },
  }),
);

export default function CreatePostButton(props: IPostActionButton) {
  const { handleAction, shouldNav, className = null } = props;
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const userId = useSelector((state: any) => state.auth.currUser.uid);
  const postConfig = useSelector((state: any) => state.posts.listConfig);
  const newUserState = useSelector((state: any) => state.auth.newUser);
  const history = useHistory();

  const handleClick = async (event: any) => {
    event.preventDefault();
    if (props.displayOnly) {
      return null;
    }
    if (handleAction) {
      handleAction();
    } else {
      setAppLoadingState(dispatch, true);
      await createPostAction(userId, dispatch);
      getPostsAction(userId, postConfig, dispatch);
      setAppLoadingState(dispatch, false);

      if (newUserState) {
        dispatch(newUser(false));
      }

      if (shouldNav) {
        history.push('/admin');
      }
    }
  };

  return props.iconOnly ?
    (<AddCircleIcon onClick={handleClick}
      className={`${classes.colorPrimary} ${className}`} />) :
    (
      <Grid item container direction="column" xs={1}
        className={`${classes.root} ${className}`}
        onClick={handleClick}>
        <Grid item>
          <AddCircleIcon />
        </Grid>
        <Grid item>
          Add
        </Grid>
      </Grid>
    );
}
